export const InterfaceMock = () => {
  return (
    <svg
      width="118"
      height="122"
      viewBox="0 0 118 122"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect
        x="0.354385"
        y="1.00844"
        width="116.77"
        height="119.982"
        rx="3.35803"
        fill="#FFFDF9"
        stroke="#B5B2AA"
        strokeWidth="0.72"
      />
      <rect
        x="11.1519"
        y="17"
        width="95.1816"
        height="40.3308"
        rx="2"
        fill="#F9F7F3"
      />
      <rect
        x="11.1519"
        y="61.6172"
        width="95.1816"
        height="32.7187"
        rx="2"
        fill="#F9F7F3"
      />
      <rect
        x="18.5942"
        y="23.6934"
        width="73.617"
        height="3.71803"
        rx="1.85901"
        fill="#ECE9DF"
      />
      <rect
        x="18.5859"
        y="72.0273"
        width="80.3094"
        height="3.71803"
        rx="1.85901"
        fill="#ECE9DF"
      />
      <rect
        x="18.5859"
        y="80.2051"
        width="54.2832"
        height="3.71803"
        rx="1.85901"
        fill="#ECE9DF"
      />
      <rect
        x="35.2393"
        y="100"
        width="47"
        height="13"
        rx="6.5"
        fill="#ECE9DF"
      />
      <path
        d="M57.6144 110.873L61.9419 105.717H59.8644V102.061L55.5369 107.217H57.6144V110.873Z"
        fill="#FF4F00"
      />
      <path
        d="M22.872 48.6636H34.8498C35.7948 48.6636 36.5609 47.8743 36.5609 46.9006V34.5598C36.5609 33.5862 35.7948 32.7969 34.8498 32.7969H22.872C21.927 32.7969 21.1609 33.5862 21.1609 34.5598V46.9006C21.1609 47.8743 21.927 48.6636 22.872 48.6636ZM22.872 48.6636L32.2831 38.9673L36.5609 43.3747M27.1498 37.645C27.1498 38.3753 26.5752 38.9673 25.8664 38.9673C25.1577 38.9673 24.5831 38.3753 24.5831 37.645C24.5831 36.9148 25.1577 36.3228 25.8664 36.3228C26.5752 36.3228 27.1498 36.9148 27.1498 37.645Z"
        stroke="#D7D3C9"
        strokeWidth="2.48889"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
